import styled from 'styled-components'
import { TextAreaProps } from '@elamajs/ui-kit'

export const TextArea = styled.textarea<TextAreaProps>`
  > textarea {
    border: 1px solid #c2c7d6;
    border-radius: 5px;

    font-size: 14px !important;
    line-height: 20px;
    color: #292e3d;

    font-family: 'Navigo', Arial, Helvetica, sans-serif;

    &::placeholder {
      color: #a3abc2;
    }

    &:hover {
      border: 1px solid #c2c7d6;
      box-shadow: inset 0 0 0 1px #c2c7d6;
    }

    &:active,
    &:focus {
      border-color: #3a64f8;
      box-shadow: none !important;
    }
  }
`
